var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"text-left",class:_vm.extraClasses,attrs:{"scope":"row"}},[_vm._t("heading",function(){return [_vm._v(" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }